import { clientContext } from '../client/context';
import { clientLogCollector } from '../client/debugger/log-collector';
import { loadBrowserInfo } from './browser-info';
import { nativeService } from '../native/service';

export const loadDebugBlob = async ():Promise<any> => {
  return {
    cc: clientContext,
    browser: await loadBrowserInfo(),
    nativeService: {
      isConnected: nativeService.isConnected,
      context: nativeService.context,
    },
    logs: clientLogCollector.logs.map(l => `${l.date}) [${l.type}] ${l.msg || ''}`).join('\n'),
  };
};

